// angular
// 	.module("HeroPRO")
// 	.controller("AppDetailController", AppDetailController);

import _ from 'lodash';
import './appDetail.scss';

/* @ngInject */
export default function AppDetailController(
    $state, $scope, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, $q, $stateParams, ConfirmLeaveFactory, $analytics, $window, HPConfig,
							 HPStateMachineConfig, $uibModal, raSpinnerService, WalkthroughFactory, HPPipelineStages, hpLoggerService
) {
    const vm = this;
    let pipelineStageName = '';

    vm.primaryInformationSticky = false;
    vm.primaryInformationLoading = true;
    vm.stateMachineData = {};
    vm.projectDetails = {};
    vm.paymentInstructions = {};
    vm.fundingRequest = {};
    vm.otherDocuments = {};
    vm.CCDocument = null;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.submitProjectForFunding = function (caseType) {
        const attachments = [];
        // Loop through the otherDocuments and retrieve the AttachmentID of documents with a status of 1
        for (let i = 0; i < vm.otherDocuments.length; i++) {
            for (let j = 0; j < vm.otherDocuments[i].AttachmentDetails.length; j++) {
                if (vm.otherDocuments[i].AttachmentDetails[j].Status === 1) {
                    attachments.push({ AttachmentId: vm.otherDocuments[i].AttachmentDetails[j].AttachmentDetail.AttachmentId });
                }
            }
        }

        // Loop through the CC and retrieve the AttachmentID of documents with a status of 1
        for (let k = 0; k < vm.CCDocument.AttachmentDetails.length; k++) {
            if (vm.CCDocument.AttachmentDetails[k].Status === 1) {
                attachments.push({ AttachmentId: vm.CCDocument.AttachmentDetails[k].AttachmentDetail.AttachmentId });
            }
        }

        const params = {
            FundingRequestId: $stateParams.appId,
            Attachments: attachments,
            CaseType: caseType,
            // CaseType 11 = New Funding Submission
            // CaseType 12 = Funding Re-Submission
        };

        raSpinnerService.show('walkthroughSpinner');
        FRClosingFactory.submitProjectForFunding(params).then((response) => {
            if (!!response.data.Data.CaseId) {
                FRInformationFactory.setStateMachineData(4, 4, HPStateMachineConfig.Loan.Fin_Docs_Signed_By_All_PO, HPStateMachineConfig.FR.Documents_Submitted);
            }
            WalkthroughFactory.loadWalkthrough();
            raSpinnerService.hide('walkthroughSpinner');
        });
    };

    vm.projectDetailsConfirmed = function () {
        return FRClosingFactory.getProjectDetailsConfirmed();
    };

    vm.paymentInstructionsConfirmed = function () {
        return FRClosingFactory.getPaymentInstructionsConfirmed();
    };

    vm.showDocumentUploadLinks = function () {
    // Hide the document upload links after the project has been submitted
    // Show the document upload links if the project has been rejected or if it is ready for resubmission
        return (!!vm.fundingRequest.FundingRequestDetail && !!vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed && vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed !== false) || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents;
    };

    vm.showGlobalDocumentUploadLink = function () {
    // Hide the global document upload link until payment instructions have been confirmed
    // Hide the global document upload link after the project has been submitted
    // Show the global document upload link if the project has been rejected or if it is ready for resubmission
        return (!!vm.fundingRequest.FundingRequestDetail && !!vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed && vm.fundingRequest.FundingRequestDetail.ContractorCaseSubmissionAllowed !== false && vm.paymentInstructionsConfirmed() === true) || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.Closer_Rejected_Documents || vm.stateMachineData.FundingRequestStateId === HPStateMachineConfig.FR.CO_Corrects_Documents;
    };

    vm.scrollPointTriggered = function (distance, element, edge) {
        vm.primaryInformationSticky = (!!edge);
        // Need to force a digest here so that the $observe in primaryInformationDirective is triggered
        $scope.$digest();
    };

    vm.openMakeChangesModal = function () {
        if(vm.appInfo.UnderwriterLock)
        {
            $uibModal.open({
                templateUrl: 'app/appDetail/makeChangesModal/makeChangesModalLocked.html',
                windowClass: 'make-changes-modal',
                controller: 'MakeChangesModalController',
                controllerAs: 'makeChangesModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                animation: false,
                scope: $scope,
            });
        }
        else
        {
            $uibModal.open({
                templateUrl: 'app/appDetail/makeChangesModal/makeChangesModal.html',
                windowClass: 'make-changes-modal',
                controller: 'MakeChangesModalController',
                controllerAs: 'makeChangesModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                animation: false,
                scope: $scope,
            });
        }
    };

    vm.openPaymentInstructionsModal = function () {
        $uibModal.open({
            templateUrl: 'app/appDetail/paymentInstructions/paymentInstructionsModal.html',
            windowClass: 'payment-instructions-modal',
            controller: 'PaymentInstructionsModalController',
            controllerAs: 'paymentInstructionsModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope,
        });
    };

    vm.openGetSignaturesModal = function (activeTab) {
        $uibModal.open({
            templateUrl: 'app/appDetail/getClosingSignaturesModal/getSignaturesModal.html',
            controller: 'GetSignaturesModalController',
            controllerAs: 'getSignaturesModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope,
            resolve: {
                activeTab() {
                    return activeTab;
                },
            },
        });
    };

    vm.rateAfterDiscount = function(rate, discountRate) {
        rate = rate || 0;
        discountRate = discountRate || 0;

        rate = parseFloat(rate);
        discountRate = parseFloat(discountRate);

        let r = rate - discountRate;
        r *= 100;
        r = Math.round(r);
        r /= 100;
        if (r <= 0) r = 0;
        return r;
    };

    vm.openUploadDocumentsModal = function (documentInfo) {
        
        hpLoggerService.info("collecting documentInfo", "AppDetailController", "openUploadDocumentsModal", documentInfo);
        
        $uibModal.open({
            templateUrl: 'app/appDetail/documents/uploadDocumentsModal/uploadModalTemplate.html',
            windowClass: 'upload-documents-modal',
            controller: 'UploadModalController',
            controllerAs: 'uploadModal',
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            animation: false,
            scope: $scope,
            resolve: {
                documentInfo() {
                    return documentInfo;
                },
            },
        });
    };

    vm.openProjectHistoryModal = function () {
        $analytics.eventTrack('View Project History', { category: pipelineStageName });
        $uibModal.open({
            templateUrl: 'app/appDetail/projectHistory/projectHistoryModal.html',
            windowClass: 'project-history-modal',
            controller: 'ProjectHistoryModalController',
            controllerAs: 'projectHistoryModal',
            size: 'full-screen',
            scope: $scope,
            resolve: {
                fundingRequestId() {
                    return $stateParams.appId;
                },
            },
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function init() {
        $scope.$on('HPLocationChange', ConfirmLeaveFactory);
                
        FRInformationFactory.getFundingRequestInformation().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
            vm.primaryInformationLoading = false;
            setStageName();
        });

        FRClosingFactory.getFundingRequestClosing().then(() => {
            vm.projectDetails = FRClosingFactory.getProjectDetails();
            vm.paymentInstructions = FRClosingFactory.getPaymentInstructions();
            vm.fundingRequest = FRClosingFactory.getFundingRequest();
            raSpinnerService.hide('walkthroughSpinner');
        });

        FRDocumentsFactory.getFundingRequestDocuments().then(() => {
            vm.otherDocuments = FRDocumentsFactory.getOtherDocuments();
            vm.CCDocument = FRDocumentsFactory.getCCDocument();
        });
    }

    function setStageName() {
        let currentStage = '';
        if (vm.stateMachineData.PipelineStageId === HPPipelineStages.GetPaid.pipelineStageId || vm.stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
            // Use the FundingRequest pipeline stage id and not the loan stage id for GetPaid and Closed.
            currentStage = vm.stateMachineData.FundingRequestPipelineStageId;
        } else {
            // For all other pipeline stages, the use the loan stage id
            currentStage = vm.stateMachineData.PipelineStageId;
        }
        // Get Stage Name from Pipeline Stages constant
        const stageName = _.filter(HPPipelineStages, stage => stage.pipelineStageId === currentStage);
        pipelineStageName = stageName[0].name;
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/appDetailController.js